import { render, staticRenderFns } from "./EmpBasic.vue?vue&type=template&id=d76a5354&"
import script from "./EmpBasic.vue?vue&type=script&lang=js&"
export * from "./EmpBasic.vue?vue&type=script&lang=js&"
import style0 from "./EmpBasic.vue?vue&type=style&index=0&id=d76a5354&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports